<template>
  <div id="app">

    <header class="container">
      <div class="row">
        <div class="col-md-4">
          <img id="logo" src="./assets/jetbov.png">
        </div>
        <div class="col-md-8">
          <div>
          <h1 class="title">{{ msg }}</h1>
          </div>
        </div>
      </div>
    </header>

<hr class="mb-4">

    <div class="container">
      <div class="mb-5 text-center">
        <h2>Formulário de pagamento</h2>
        <p class="lead">Abaixo, você informa os dados para registro do seu plano, sua fazenda e o envio da cobrança.</p>
      </div>

      <div class="row">
        <div class="col-md-4 order-md-2 mb-4">
          <h4 class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted">Sua compra:</span>
          </h4>
          <ul class="list-group mb-3">
            <li class="list-group-item d-flex justify-content-between lh-condensed bg-green">
              <div>
                <h5 class="listitem">Plano: Pecuária Digital</h5>
                <small class="text-justify">
                  Este plano atende a pecuaristas que desejam abandonar o
                  caderno de campo para ter um controle e
                  histórico digital da fazenda. Pequenas fazendas que tem a 
                  pecuária como um hobby ou segunda atividade.
                </small>
              </div>
            </li>
            <li class="list-group-item d-flex justify-content-between lh-condensed bg-green">
              <div>
                  <a href="https://jetbov.com/planos-e-precos/" target="_new">Compare com os outros planos</a>
              </div>
            </li>
            <li class="list-group-item d-flex justify-content-between lh-condensed bg-green-1">
              <div>
                <h6 class="listitem">Assinatura: Mensal</h6>
                <small class="text-dark">Válidade até: {{new Date() | moment('add', '1 months', "D/MM/YYYY")}} </small>
              </div>
            </li>
            <li class="list-group-item d-flex justify-content-between bg-green-1">
              <span>Total (BRL)</span>
              <strong>R$ {{formatPrice(pagamento.faixas[dados.quantidade_de_animais] * pagamento.valor_base)}}</strong>
            </li>
          </ul>

          <h2>Informações</h2>
          <p>
            Utilizamos a plataforma de cobrança chamada Asaas. Você receberá notificações desta plataforma.
            A nota fiscal será emitida assim que confirmado o pagamento.
          </p>
          <p>
            Após efetuar o pagamento, entre em contato com nossa equipe para validar seu usuário e
            plano no Jetbov através do email financeiro@jetbov.com informando o email utilizado no pagamento 
            ou pelo telefone: (47) 3512 0023.
          </p>
          <p>
          Ao confirmar seus dados você esta aceitando nossos: <a class="btn btn-block btn-success" href="https://jetbov.com/termos-de-licenciamento-jetbov/" target="_blank"> Termos de licenciamento</a>
          </p>

        </div>
        <div class="col-md-8 order-md-1">
          <form name="form" id="frmPayment" class="needs-validation" novalidate>
            <h4 class="mb-3">Detalhes do plano</h4>

            <div class="row mb-3">
              <div class="col-md-6">
                <label for="cc-number">Quantidade de animais desejados neste plano:</label>
              </div>
              <div class="col-md-6">
                <select class="custom-select d-block w-100" id="state" v-model="dados.quantidade_de_animais" required>
                  <option value="100">Até 100 animais</option>
                  <option value="200">Até 200 animais</option>
                  <option value="300">Até 300 animais</option>
                  <option value="400">Até 400 animais</option>
                  <option value="500">Até 500 animais</option>
                  <option value="600">Até 600 animais</option>
                  <option value="700">Até 700 animais</option>
                  <option value="800">Até 800 animais</option>
                  <option value="900">Até 900 animais</option>
                  <option value="1000">Até 1000 animais</option>
                  <option value="1100">Até 1100 animais</option>
                  <option value="1200">Até 1200 animais</option>
                  <option value="1300">Até 1300 animais</option>
                  <option value="1400">Até 1400 animais</option>
                  <option value="1500">Até 1500 animais</option>
                  <option value="1600">Até 1600 animais</option>
                  <option value="1700">Até 1700 animais</option>
                  <option value="1800">Até 1800 animais</option>
                  <option value="1900">Até 1900 animais</option>
                  <option value="2000">Até 2000 animais</option>
                </select>
              </div>
            </div>
            <hr class="mb-4">
            <h4 class="mb-3">Dados de contato</h4>
            <p><small>* Campos obrigatórios</small></p>
            <div class="row">
              <div class="col-md-7 mb-3">
                <label for="name">Nome Completo ou Razão Social*</label>
                <input type="text" class="form-control" v-model="dados.nome" id="firstName" placeholder="Seu nome" value="" required>
                <div class="invalid-feedback">
                  É necessário informar seu nome
                </div>
              </div>
              <div class="col-md-5 mb-3">
                <label for="cpfcnpj">{{cpf_type}}*</label>
                <input type="text" class="form-control" :class="{'is-invalid': cpf_isValid === false && dados.cpfcnpj != ''}" 
                       v-mask="['###.###.###-##', '##.###.###/####-##']"
                       @blur="valida_cpf" v-model="dados.cpfcnpj" id="cpf" placeholder="xxx.xxx.xxx-xx" value="" required>
                <div class="invalid-feedback">
                  É necessário informar seu CPF ou CNPJ corretamente
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-7">
                <label for="email">E-mail*</label>
                <input type="email" class="form-control" v-model="dados.email" id="email" placeholder="seu@dominio.com" required>
                <div class="invalid-feedback">
                  É necessário informar o email para cobrança
                </div>
              </div>
              <div class="col-md-5">
                <label for="inscr_estadual">Inscrição Estadual</label>
                <input type="text" class="form-control" v-model="dados.incricao_estadual" id="inscr_estadual" placeholder="">
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <label for="phone">Telefone fixo</label>
                <input type="text" class="form-control" id="phone" 
                       v-mask="['(##) ####-####', '(##) #####-####']"
                       v-model="dados.telefone" placeholder="(00) 0000-0000" value="">
              </div>
              <div class="col-md-6">
                <label for="mobilePhone">Telefone celular*</label>
                <input type="text" class="form-control" id="mobilePhone" 
                       v-mask="['(##) ####-####', '(##) #####-####']"
                       v-model="dados.celular" placeholder="(00) 9 0000-0000" value="" required>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-3">
                <label for="zip">Cep*</label>
                <input type="text" class="form-control" id="zip" @blur="valida_cep" v-mask="'#####-###'"
                       :class="{'is-invalid': cep_isValid === false && dados.cep != ''}"
                        v-model="dados.cep" placeholder="99999999" required>
                <div class="invalid-feedback">
                  Digite CEP válido
                </div>
              </div>

              <div class="col-md-5">
                <label for="address">Endereço*</label>
                <input type="text" class="form-control" id="address" v-model="dados.endereco" placeholder="Nome da rua..." required>
                <div class="invalid-feedback">
                  Informe o endereço da sua fazenda
                </div>
              </div>

              <div class="col-md-4">
                <label for="address">Bairro*</label>
                <input type="text" class="form-control" id="address" v-model="dados.bairro" placeholder="bairro..." required>
                <div class="invalid-feedback">
                  Informe o bairro
                </div>
              </div>

            </div>

            <div class="row mb-3">
              <div class="col-md-3">
                <label for="addressNumber">Número*</label>
                <input type="text" class="form-control" id="addressNumber" v-model="dados.endereco_nro" placeholder="1234" required>
                <small class="text-muted">Informe o nro ou 's/n'</small>
                <div class="invalid-feedback">
                  Informe o número
                </div>
              </div>
              <div class="col-md-5">
                <label for="addressComplement">Complemento</label>
                <input type="text" class="form-control" id="addressComplement" 
                       v-model="dados.endereco_complemento" placeholder="" >
              </div>
              <div class="col-md-4">
                <label for="state">Estado*</label>
                <select class="custom-select d-block w-100" id="state" v-model="dados.estado" required>
                  <option value="">Escolha...</option>
                  <option value="AC">Acre</option>
                  <option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option>
                  <option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option>
                  <option value="CE">Ceará</option>
                  <option value="DF">Distrito Federal</option>
                  <option value="ES">Espírito Santo</option>
                  <option value="GO">Goiás</option>
                  <option value="MA">Maranhão</option>
                  <option value="MT">Mato Grosso</option>
                  <option value="MS">Mato Grosso do Sul</option>
                  <option value="MG">Minas Gerais</option>
                  <option value="PA">Pará</option>
                  <option value="PB">Paraíba</option>
                  <option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option>
                  <option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option>
                  <option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option>
                  <option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option>
                  <option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option>
                  <option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option>
                </select>
                <div class="invalid-feedback">
                  Selecione um estado
                </div>
              </div>

            </div>

            <hr class="mb-4">
            <h4 class="mb-3">Dados de pagamento</h4>

            <!-- <div class="d-block my-3"> -->
              <!-- <div class="custom-control custom-radio">
                <input id="boleto" class="custom-control-input" name="paymentMethod" v-model="payment" value="boleto" type="radio" checked>
                <label class="custom-control-label" for="boleto">Boleto</label>
              </div> -->
              <!-- <div class="custom-control custom-radio">
                <input id="credito" class="custom-control-input"  name="paymentMethod" v-model="payment" value="credito" type="radio">
                <label class="custom-control-label" for="credito">Cartão de crédito</label>
              </div> -->
            <!-- </div> -->
            <div v-if="payment === 'credito'">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label for="cc-number">Número do cartão</label>
                  <input type="text" class="form-control" v-mask="'#### #### #### ####'" id="cc-number" v-model="dados.cartao.numero" placeholder="9999 9999 9999 9999" required>
                  <div class="invalid-feedback">
                    O número é obrigatório
                  </div>
                </div>
                <div class="col-md-5 mb-3">
                  <label for="cc-expiration">Data de vencimento</label>
                  <input type="text" class="form-control" id="cc-expiration" 
                         v-model="dados.cartao.vencimento" placeholder="MM/AAAA" v-mask="'##/####'" required>
                  <div class="invalid-feedback">
                    Informe o vencimento
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-7 mb-3">
                  <label for="cc-name">Nome no cartão</label>
                  <input type="text" class="form-control" id="cc-name" v-model="dados.cartao.nome" placeholder="" required>
                  <small class="text-muted">O nome exatamente como aparece no cartão</small>
                  <div class="invalid-feedback">
                    O nome no cartão é obrigatório
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="cc-cvv">Código de segurança</label>
                  <input type="text" class="form-control" v-mask="['###','####']" id="cc-cvv" placeholder="" v-model="dados.cartao.cvv" required>
                  <div class="invalid-feedback">
                    Informe o código de segurança
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p class="text-muted"><strong>Obs:</strong> Utilizamos uma plataforma de cobrança e não armazenamos os dados do seu cartão. </p>
                </div>
              </div>
            </div> <!-- v-if credito -->
            <div v-else>
              <p>O boleto será gerado e enviado para seu email assim que você preencher os dados.</p>
            </div>
            <hr class="mb-4">
            <div v-if="loading">
                Aguarde até que sua requisição seja processada...
            </div>
            <button :disabled="loading" class="btn btn-primary btn-lg btn-block" @click="sendData" type="button">Confirmar compra</button>
          </form>
        </div>

      </div>

      <div id="myModal" class="modal">

        <!-- Modal content -->
        <div class="modal-content">
          <!-- <span class="close">&times;</span> -->
          <p><a href="https://app.jetbov.com/"><img id="trialimage" src="/dist/trial.jpeg" alt="Faça seu teste no Jetbov!"></a></p>
        </div>

      </div>


    </div> <!-- container -->

    <footer class="my-5 pt-5 text-muted text-center text-small">
      <p class="mb-1">&copy; Jetbov - Todos os direitos reservados</p>
      <ul class="list-inline">
        <li class="list-inline-item"><a href="https://jetbov.com/termos-de-licenciamento-jetbov/">Termo de licenciamento</a></li>
        <li class="list-inline-item"><a href="https://jetbov.com/conteudos/">Conteúdos</a></li>
      </ul>
    </footer>
  </div>

</template>

<script>
import {verifica_cpf_cnpj, valida_cpf_cnpj} from './cpfcnpj.js';

var cpfvalido = function(){
  let valor = document.getElementById("cpf").value;
  if(!valida_cpf_cnpj(valor)){
    this.cpf_message = 'Número cpf/cnpj inválido';
    return false;
  }else{
    this.cpf_message = ''
  }
  this.cpf_type = verifica_cpf_cnpj(value) || "CPF/CNPJ";
  return true;
}

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

export default {
  name: 'app',
  data () {
    return {
      pagamento: {
        valor_base: 109.9,
        faixas:{
        //QtdDeAnimais: multiplicador/parcelas
          100: 1,
          200: 2,
          300: 3,
          400: 4,
          500: 5,
          600: 6,
          700: 7,
          800: 8,
          900: 9,
          1000: 10,
          1100: 11,
          1200: 12,
          1300: 13,
          1400: 14,
          1500: 15,
          1600: 16,
          1700: 17,
          1800: 18,
          1900: 19,
          2000: 20,
        }
      },
      loading: false,
      infoMessage: '',
      msg: 'Você está a poucos passos de fazer sua fazenda crescer!',
      nome: '',
      telefone: '',
      email: '',
      payment: 'credito',
      info: '',
      dados: {
        quantidade_de_animais: 100,
        multiplicador: 1,
        cpfcnpj: '',
        cartao: {},
        cep: '',
        acesso: 'sem-info',
        pais: 'BR',
        endereco: '',
        endereco_complemento: '',
        estado: '',
        bairro: ''
      },
      cpf_message: '',
      cpf_type: 'CPF/CNPJ',
      cpf_isValid: false,
      cep_isValid: false
    }
  },
  created: function () {
    mixpanel.track("Entered payment page");
  },
  mounted:function(){
    var vm = this;
    window.setTimeout(function(){
      console.log(!vm.dados.nome, vm.dados.quantidade_de_animais == 500, isEmpty(vm.dados.cartao), !vm.dados.endereco);
      if(!vm.dados.nome && vm.dados.quantidade_de_animais == 500 && isEmpty(vm.dados.cartao) && !vm.dados.endereco){
        var modal = document.getElementById("myModal");
        modal.style.display = "block";
      }
    }, 10000);
  },
  methods: {
    showValorPlano () {
      return "Plano de até <strong>" + this.dados.quantidade_de_animais + '</strong> animais</br>' 
             + 'Em <span class=\'parcela\'>' + this.pagamento.faixas[this.dados.quantidade_de_animais] + 'x '
             + 'de R$ ' + this.pagamento.valor_base + ',00</span>'

    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    sendData () {
      mixpanel.track("Trying to pay");
      
      var vm = this;
      var forms = document.getElementsByClassName('needs-validation')
      
      if (forms[0].checkValidity() === false) {
        forms[0].classList.add('was-validated')
        this.$swal({
          title: 'Dados inválidos',
          text: 'Preencha todos os campos obrigatórios conforme instruções na tela',
          type: 'warning',
          confirmButtonText: 'Verificar dados',
        });
      }else{
        
        if( vm.dados.acesso === 'novo' && 
            (vm.dados.nova_senha != vm.dados.nova_senha_repite || 
             vm.dados.nova_senha == '' || 
             vm.dados.nova_senha_repite == '') ){
          this.$swal({
            title: 'Dados inválidos',
            text: 'As senhas precisam ser preenchidas iguais',
            type: 'warning',
            confirmButtonText: 'Verificar dados',
          });
          return
        }
        
        if( !vm.cpf_isValid ){
          this.$swal({
            title: 'Dados inválidos',
            text: 'É necessário informar um CPF/CNPJ válido',
            type: 'warning',
            confirmButtonText: 'Verificar dados',
          });
          return
        }

        if( !vm.cep_isValid ){
          this.$swal({
            title: 'Dados inválidos',
            text: 'É necessário informar um CEP válido',
            type: 'warning',
            confirmButtonText: 'Verificar dados',
          });
          return
        }

        let aditional = {
          headers : {
            'x-api-key': 'OpSlr1na7fa1RDyUFELpM7Jr1cHexP7k9uRgC5hi',
            'Content-Type': 'application/json',
          }
        }
        vm.loading = true;
        vm.dados.multiplicador = parseInt(vm.pagamento.faixas[vm.dados.quantidade_de_animais])

        // Envia os dados para o servidor
        this.$http
          .post('https://q02vq4vz8c.execute-api.us-east-1.amazonaws.com/default/criarUsuarioEPagamento', vm.dados, aditional)
          .then(function(response){

            mixpanel.track("Payment successfull");
            // mixpanel.alias(vm.dados.email_acesso);
            mixpanel.alias(vm.dados.email);

            var json = {
              token_rdstation: "7f79a796fd1f3eeebb51ab906fd7e3bf",
              //Obrigatório - Token Publico de autenticação
              identificador: "plan-payment",
              //Obrigatório
              // email: vm.dados.email_acesso,
              email: vm.dados.email,
              //Obrigatório
              nome: vm.dados.nome,
              telefone: vm.dados.celular,
              tags: "HAS_USER"
            };
            vm.$http.post("https://www.rdstation.com.br/api/1.3/conversions", json);

            // console.log(response.data)
            vm.$swal({
              title: 'Transação confirmada',
              html: 'Seja muito bem-vindo ao Jetbov! <br>' + 
                    'Seu pagamento está sendo processado. <br>' + 
                    'Caso haja algum problema entre em contato conosto:<br>' + 
                    '<small>Whats: (47) 999 450 775 ou (47) 3512 0023<br>' + 
                    'Email: financeiro@jetbov.com</small>',
              type: 'success',
              confirmButtonText: 'Obrigado!',
            }).then(function(){
              window.location = "https://www.jetbov.com/tutoriais";
            });

          }).catch(function(error){
            mixpanel.track("Payment error");
            if (error.response) {
              this.$swal({
                title: 'Erro ao processar os dados',
                text: error.response.data,
                type: 'error',
                confirmButtonText: 'Ok',
              });
            } else {
              this.$swal({
                title: 'Erro ao processar os dados',
                text: "Ocorreu um erro na sua requisição, tente novamente mais tarde",
                type: 'error',
                confirmButtonText: 'Ok',
              });
              // console.log('Error', error.message);
            }
            // console.log(error.config);
          }).finally(function(){
            vm.loading = false;
          })

      }

    },
    valida_cep(event){
      var vm = this;
      let value = event.target.value;
      this.$http.get('https://viacep.com.br/ws/' + value + '/json'
      ).then(function(response){
        if(response.data.erro){
          vm.cep_isValid = false;
          vm.dados.endereco = response.data.logradouro;
          vm.dados.bairro = response.data.bairro;
          vm.dados.endereco_complemento = response.data.complemento;
        }else{
          vm.dados.endereco = response.data.logradouro;
          vm.dados.endereco_complemento = response.data.complemento;
          vm.dados.bairro = response.data.bairro;
          vm.dados.estado = response.data.uf;
          vm.cep_isValid = true;
        }
      }).catch(function (error){
          vm.cep_isValid = false;
          vm.dados.endereco = '';
          vm.dados.bairro = '';
          vm.dados.endereco_complemento = '';
      });
    },
    valida_cpf(event) {
      let value = event.target.value;
      if(!valida_cpf_cnpj(value)){
        this.cpf_message = 'Número cpf/cnpj inválido';
        this.cpf_isValid = false;
      }else{
        this.cpf_message = ''
        this.cpf_isValid = true;
      }
      this.cpf_type = verifica_cpf_cnpj(value) || "CPF/CNPJ";
    }
  }
}

window.onclick = function(event) {
  var modal = document.getElementById("myModal");
  if (event.target == modal) {
    modal.style.display = "none";
  }
} 
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
}

header {
  text-align: center;
}

.container {
  max-width: 960px;
}

.lh-condensed { line-height: 1.25; }

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

#logo {
  max-width: 200px;
}

.valorplano{
  text-align: center;
  width: 100%;
}

.parcela{
  text-decoration: underline;
}


 /* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 5% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  max-width: 840px;
  max-height: 600px;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
} 

#trialimage{
  max-width: 800px;
}

.bg-green {
  background-color: #bddfb8fa;
}
.bg-green a{
  color: #2c3e50;
  text-decoration: underline;
}

.bg-green-1 {
  background-color: #5af87dc7;
}

.listitem{
  font-weight: bold;
}
.title{
  height: 200px;
  line-height: 70px;
  vertical-align: middle;
  padding-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue